<template>
  <div class="unitInFormation">
    <div class="unitInFormation_content">
      <el-form ref="form" :model="nowUnitInfo" label-width="80px">
        <el-form-item label="单位名称">
          <el-input v-model="nowUnitInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="单位全称">
          <el-input v-model="nowUnitInfo.fullName"></el-input>
        </el-form-item>
        <el-form-item label="单位编号">
          <el-input v-model="nowUnitInfo.unitCode"></el-input>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="nowUnitInfo.leader"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="nowUnitInfo.phoneNum"></el-input>
        </el-form-item>
        <el-form-item label="接入时间">
          <el-date-picker type="date" placeholder="选择日期" v-model="nowUnitInfo.joinTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="nowUnitInfo.address"></el-input>
        </el-form-item>
      </el-form>
      <!--两行来显示会更好-->
      <el-form ref="form" label-width="80px">
        <el-form-item label="单位人数">
          <el-input v-model="nowUnitInfo.unitPeopleNumber"></el-input>
        </el-form-item>
        <el-form-item label="单位面积">
          <el-input v-model="nowUnitInfo.unitArea"></el-input>
        </el-form-item>
        <el-form-item label="能耗指标">
          <el-input v-model="nowUnitInfo.energIndex"></el-input>
        </el-form-item>
        <el-form-item label="节能比例">
          <el-input v-model="nowUnitInfo.energySavingRatio"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="nowUnitInfo.memo"></el-input>
        </el-form-item>
        <el-form-item label="" style="margin-top: 40px;">
          <el-button @click="getUnitInfo" class="unitCancelButton">取消</el-button>
          <el-button type="primary" @click="saveUnitInfo">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import meterManagerStore from './meterManagerStore.js'
  export default {
    components: {

    },
    props: {},
    data () {
      return {
        nowUnitInfo: {
          "leader": "陈焕龙",
          "unitNo": 40,
          "memo": "",
          "phoneNum": "",
          "type": 0,
          "capacity": 0,
          "entityName": "UsePowerUnit",
          "unitCode": "001",
          "logo": null,
          "id": "B5A693FA77804BC8BE009D57D0E7A788",
          "roomCount": 2,
          "inletWire": "",
          "address": "111",
          "joinTime": 1582685961000,
          "fullName": "广西学校能源管理电力科技有限公司",
          "sort": 1,
          "parentId": "",
          "transformerCount": 0,
          "unitArea": null,
          "createTime": 1706165958000,
          "expirationTime": 1582685961000,
          "energIndex": null,
          "name": "学校能源管理",
          "loadCapacity": 2100,
          "location": "113.606238,34.391428",
          "unitPeopleNumber": null,
          "energySavingRatio": null,
          "watchCount": null
        },
      }
    },
    created () {
      this.getUnitInfo()
    },
    mounted () {},
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {},
    methods: {
      getUnitInfo () {
        this.$api.unitApi.getUnit(this.nowUnit.id,respon => {
          this.nowUnitInfo=respon
        })
      },
      saveUnitInfo () {
        let joinTime=new Date(this.nowUnitInfo.joinTime).getTime()
        this.$api.unitApi.saveUnit(this.nowUnitInfo.id,this.nowUnitInfo.type,
          this.nowUnitInfo.parentId,this.nowUnitInfo.unitCode,
          this.nowUnitInfo.name,this.nowUnitInfo.fullName,
          this.nowUnitInfo.address,this.nowUnitInfo.leader,
          this.nowUnitInfo.phoneNum,this.nowUnitInfo.memo,
          this.nowUnitInfo.sort,this.nowUnitInfo.capacity,
          this.nowUnitInfo.inletWire,this.nowUnitInfo.location,joinTime,
          this.nowUnitInfo.expirationTime,this.nowUnitInfo.roomCount,
          this.nowUnitInfo.transformerCount,this.nowUnitInfo.loadCapacity,
          this.nowUnitInfo.unitArea,this.nowUnitInfo.unitPeopleNumber,
          this.nowUnitInfo.energIndex,this.nowUnitInfo.energySavingRatio,respon => {
            this.nowUnitInfo=copy(respon)
            this.$message.success('保存成功')
          },err => {
            this.$message.warning('保存失败')
          })
      },
    }
  }
</script>
<style>
  .unitInFormation {
    background-color: #11173c !important;
    padding: 20px;
    height: calc(100% - 40px);
  }

  .unitInFormation_content {
    border: .01rem solid #0263ff;
    width: 60%;
    height: 85%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .unitInFormation .el-form {
    width: 50%;
    height: 100%;
  }

  .unitInFormation .el-form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
  }

  .unitInFormation label {
    margin-left: 80px;
    color: #ffffff;
    display: block;
    text-align: left;

  }

  .unitInFormation .el-input {
    width: 90%;
    color: #ffffff;
  }

  .unitInFormation .el-input .el-input__inner {
    background-color: #002369;
    color: #ffffff;
    border-color: #0149c3;
  }

  .unitInFormation .el-input .el-input__inner:focus {}

  .unitInFormation .el-textarea {
    width: 90%;
  }

  .unitInFormation .el-textarea .el-textarea__inner {
    background-color: #002369;
    color: #ffffff;
    border-color: #0149c3;
  }

  .unitInFormation textarea {
    height: 250px;
  }

  /*按钮样式*/
  .unitInFormation .unitCancelButton {
    background-color: #002369;
    color: #ffffff;
    border-color: #0149c3;
    padding: 12px 40px;
  }

  .unitInFormation .unitCancelButton:focus,
  .unitCancelButton:hover {
    background-color: #00456b;
  }

  .unitInFormation .el-button {
    padding: 12px 40px;
  }
</style>